module.exports = require("prop-types");


//////////////////
// WEBPACK FOOTER
// external "prop-types"
// module id = 4
// module chunks = 0